module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("Rondo: December 3, 1994")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Playing left her with an empty place inside, a sense of loss as unnerving as the anxiety. She came out of the quiet place in her head to hear the last notes die away. It had almost happened this time-a tiny click of a second when the music had almost broken free and soared, incandescent. So very close.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Applause swelled, thin but enthusiastic, and the shadows in the audience turned to smiling faces. She remembered to bow and stepped aside to indicate Benny, who acknowledged her fans with both hands in the air, vest glittering like diamonds. God, it was like appearing onstage with a rock band. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tonight, ladies and gentlemen, Abigail Rhodes backed up by Aerosmith!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe she’d get a bigger audience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benny followed her offstage into the dusty velvet shadows behind the curtain, and before she could bolt out for a cigarette Abby grabbed her arm and said, “The tempo was off on the third movement, wasn’t it? Too slow?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("“No, I thought it was fine.” Benny frowned and fidgeted. “You were great. The second movement ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("was about the best I’ve ever heard you play. Why? Was I setting too slow?”")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was all she had time for because Paul came forward, beaming, to deliver a bouquet of roses tied with red ribbon. He kissed her hand awkwardly, flushed apple-red in his cheeks, and backed off as a swarm of junior high and high schoolers entered from the stage door waving programs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benny pulled away and beat it for the alley and the haven of a Marlboro. Three of the kids cut her off. One of them was Delilah Kimble, Abby’s star student—Delilah, habitually quiet and self-contained, had a glow of hero worship in her eyes. Abby shrugged off a petty jab of disappointment and smiled at the other kids crowded around her, picking out fragments of compliments like thrown roses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roses. She frowned down at the flowers and dug a card out of the center.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Best wishes")]), _vm._v(", it read.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("John Lee")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She glanced up, startled, and saw him leaning against the raw brick wall next to the stage door. He smiled to her and nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A girl tugged on her arm and said, “Miz Rhodes, I don’t want to play "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mozart")]), _vm._v(", I want to play what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Delilah’s")]), _vm._v(" playing. I like it better, can I play that one?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like you could,” a younger boy sniped. “You can’t even do the slow parts.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("“The slow parts aren’t easier,” Abby chided, and tore her gaze away from John Lee’s face to look down at them. “Jen, I think you should stick to the ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("Mozart, don’t you? You’ve practiced it so hard. And the Mozart is something everyone wants to play, especially the professionals.”")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Jen looked stubbornly down at her own feet. “You said we could play anything we wanted. My "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mom")]), _vm._v(" said I could play anything I wanted or I could get a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("new")]), _vm._v(" teacher.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby bit back the impulse to tell her to get another teacher, and good riddance. Jen wasn’t a bad kid, really, she was just spoiled. Who was she to criticize when she’d been on her knees in the bathroom half an hour before curtain? She patted the girl’s thin shoulder and said, “We’ll talk about it Wednesday, okay? Carl, did you like it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was really good,” Carl said with just the right touch of teenage superiority. Over his shoulder she glimpsed Charlie Harris—Mr. Harris, the band guru—waving and smiling as he tried to stop two junior high students from hanging on the dusty velvet curtains. The gang was all here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks.” She looked around for John Lee again. He was gone, and the musty-sweet smell of his roses was making her dizzy. Maybe he hadn’t been there at all; maybe she’d imagined him. Was she that desperate for admiration?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course she was. Why else would she go through the horror of performing?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The kids wandered off, duty done, making plans to cruise the Sonic drive-in restaurant and hang at the mall. Delilah was still in earnest conversation with Benny, who shifted from one foot to the other like a kid interrupted on the way to the bathroom.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("“Friend of yours?” said a voice from behind her, close enough that warm breath touched the back of her neck. She turned so fast she wobbled on her high heels. He moved back a polite step but the feeling of his presence stayed with her, a hot space in the chilly air.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Benny. She was my roommate in college.” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Say something intelligent")]), _vm._v(", her brain urged. “Thank you for coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What college?” He asked it like he wanted to know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Texas Tech in Lubbock. Then Cincinnati Conservatory, Certificate of Performance.” She had to stop herself from bubbling over like a pot left too long on the stove.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Lee’s gaze slid over to Benny as if magnetized. A smile crinkled the corners of his lips, and he said, “I guess conservatory must not mean conservative. She always looked like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mostly.” Abby became abruptly conscious of the roses cradled in her arms, shifted them with a springy rustle of leaves. “Thanks for the flowers. You didn’t have to do that.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("He held out his hand. She felt awkward taking it but not taking it seemed worse, so she juggled clarinet and flowers and let him fold his fingers over hers. She was unprepared for the warmth of his touch, the strength of his grip. He didn’t seem willing to let her go. He had fascinating eyes, full of secrets, and she couldn’t tell anything about what he was thinking. Like Benny, she had a tendency to date within the musical faith. She didn’t know a thing about ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("cowboys, except that he made her nervous. Maybe he played pedal steel.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You were good,” he said. “Third movement could have been a little faster.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stared at him, stricken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m kidding. You said it to your friend, remember? You were great, Abby.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sound of her name from him came as a shock. It fluttered her pulse and sent heat screaming into her cheeks. She pulled her hand free and used it to hold the roses and clarinet between them, crossed swords.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks again for Carlton. I really appreciate it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He folded his arms over his chest, rocked slightly back and forth, heel to toe. He took a long time to answer, as if he’d chosen the words carefully. “I feel like I know you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before she could stop herself she said sharply, “You don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("God, where had "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" come from? His eyes wid­ened. He kept staring, a frown grooved between his eyebrows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I guess I don’t,” he admitted. “But I think I might want to. That a problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I’m hopeless")]), _vm._v(", she thought in despair. As soon as she twelve-stepped her way out of one phobia there was always another one, coiled like a rattlesnake under a rock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want me to go?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("In the long silence that followed, she listened to the normal workday sounds of the stage lights clicking ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("off, the curtains hissing shut, the retreating footsteps of her escaping audience. The stage door slammed. Benny must have made it to the alley for her cigarette.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("John Lee hadn’t moved when she finally had the courage to look up at him again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Abby, look, you can tell me to go to hell if you want to.” He had the oddest way of turning things back on her, of seeing into her head. “I do something wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nothing.” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Everything")]), _vm._v(". “It’s just a bad time. I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hell, if you wait for the good times you’ll die waiting.” He gave her a long, level stare. “We don’t get but about three perfect minutes in our lives, but that doesn’t mean all the rest is a waste.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her lips parted, wanting to say something, but her throat wouldn’t cooperate. After a second or two the pressure eased. She didn’t need to say anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi.” A hand slid between them, long fingers outstretched. Glitter polish blinked in the dim light, and Benny angled in like a wedge behind it. “You must be John Ray.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“John Lee. John Lee Jordan,” he said, and pumped her hand with exaggerated enthusiasm. “All your people have hair like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All the ones that lived.” Benny stepped over to wrap a proprietary arm over Abby’s shoulders. “What do you think of her? Pretty good, eh?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("“Real pretty music,” he said. He’d done something to his posture, rounded his shoulders, bowed his ")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("legs, His accent had steamrolled. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ree-ul purty")]), _vm._v(". Abby didn’t know whether to laugh or slap him. “Not much of a beat, though.”")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not like Garth Brooks,” Benny agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was thinking more like Lyle Lovett. You ever two-step, ma’am?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benny laughed from the gut. “You ever been in a mosh pit at a GWAR concert?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He gave her a wicked grin. “Not this month.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benny punched Abby in the shoulder, said “I like him, he’s stupid,” and walked away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby stared after her. “Hey! Where are you going?” she called.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benny turned, a chandelier of glitter, and held her arms out in an extravagant shrug. She kept walking backward, a feat of balance that left Abby speechless. “Back to the hotel, hang out in the bar, watch some wrestling. Oh, hey, cowboy?” She looked directly into John Lee’s face and winked. “Would you mind giving her a ride home?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nope.” He tipped an imaginary hat to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s always mopey after a good concert.” Benny executed a perfect showgirl high-heeled spin and clicked away down the hall, speckles of colored light following her like a fan club of Tinkerbells.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That,” Abby said when she could speak again, “wasn’t fair. Was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nope.” John Lee reached out and took the flowers out of her arms. “I guess you’ll want to put that thing away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The clarinet. It felt so natural in her hands that it was a shock to realize she still had it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("“And after that?” she asked.")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("John Lee cocked his head and shrugged. “Dinner?” Right on cue, her stomach growled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Drive-through fast food had never tasted so good. The hamburger was deliciously perfect, the french fries the ideal mix of Idaho potato and Georgia peanut oil, the chocolate shake a thick smooth caress on her tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“See those kids over there?” she asked, and pointed with a french fry at a slow-cruising primer gray sedan. John Lee, busy sucking on a vanilla shake of his own, nodded. “Those are my kids.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He inhaled ice cream and had a coughing fit; she pounded him on the back after cramming the fries in her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("students")]), _vm._v(",” she corrected when they could both breath again. “Sorry. They’re cruising because they’re waiting for me to do something crazy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like what?” he asked, and reached for the last french fry at the same time she did. They both pulled back. “Go ahead,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, you go ahead.” They waited. The french fry remained in the lonely no-man’s-land of the checkered paper tray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re going to disappoint them?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She felt a little nervous at the glow in his large, dark eyes. “I … maybe. No. I don’t know.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("He picked up the french fry and held it out, pinned between his thumb and forefinger. She looked at it doubtfully. He cocked his head and raised his eyebrows, silently daring her; she knew without looking ")]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("that her students were cruising closer, craning their necks to see. The spectacle of Old Miz Rhodes dating a cowboy at the Sonic drive-in was irresistible.")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Just for the hell of it, she leaned forward and bit into the french fry, biting close enough that her teeth grazed his fingertips. The taste of him was startling. It tingled salty and vivid on her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For a second he sat frozen, and then he grinned and ate the half inch of severed french fry himself. She couldn’t decide what the look in his eyes was, exactly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You,” John Lee said, and started the car, “are dangerous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t think I’d do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hell, no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He backed the car out from under the aluminum shelter into the white winter sun; she shaded her eyes with one hand and twisted in her seat to watch drive­in and students disappear behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the problem,” she said, and turned back to face the front. The immediate shopping district was full of drab brick buildings with neon sale notices in the windows. Furniture sales flamed on the right. Rent-to-own advertised "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NO CREDIT REQUIRED")]), _vm._v(" in English and Spanish. “Everybody underestimates me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smiled and shifted to a more comfortable position in his seat. She decided she liked his car, new and maroon, seats as soft as kid leather. He kept the backseat clean, a habit she envied. She’d once gone an entire year in college without ever excavating the trash from the floorboards.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("“What about your folks?” he asked. He drummed ")]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("his fingers on the steering wheel, no particular pattern, and she noticed that he had nice hands, large and square and long-fingered. He had three or four irregular dark scars on the back of his fingers, finer dark lines that looked like cat scratches.")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("No wedding ring, she was relieved to notice, and no sign that there’d been one recently.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Abby?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked up, startled, and saw him watching her. Heat bloomed in her cheeks and she turned her head to look out the passenger window. Nothing to see. A few stores with Christmas sales on the sidewalk, some constipated-looking shoppers. More battered, sun-baked cars parked slantwise in front of the stores.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They live in Dallas,” she said quickly, to get it over with. “My dad’s an electrical engineer. My mother passed away seven years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He gave that the appropriate moment of silence before asking, “Any brothers or sisters?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A brother. Eddie. He’s an actuary.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“An actuary. He calculates numbers for an insurance company. Look, don’t ask me, I didn’t get a degree in it. How about your family?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Lee braked to a stop for a red light, and she leaned forward to look at the faded street sign. Spargus. They were only about a mile from her apartment. If that was where they were going. She supposed she ought to ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My mother lives up in Fall Creek. I mentioned her this morning. Pearl Jordan.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("The green and white street sign dissolved in a dust storm of gray, eaten from the edges in, and with a huge effort she took a breath and leaned back in the soft seat, falling, falling.")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("No more gray. The world went black and something pressed down on her like a second skin, cold and damp and heavy. She opened her mouth to gasp and tasted dirt, tried to scream, but there was nothing in her chest except old foul air and it couldn’t get past the lump of dirt in her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Falling")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A blast of cold wind swept over her, blowing the dirt away, and a warm pair of hands caught her and held her tight against the swirl of black and gray that tried to drown her. She swallowed and swallowed and tasted metal and blood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she opened her eyes the world steadied around her, bright and sun-faded, and John Lee was kneeling in the open passenger door, hands on her shoulders. His face had gone pale under the Texas tan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He tried twice to speak before he got her name out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked past him to the sidewalk, where a couple of curious Mexican women clutched shopping bags and whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Say that again,” she said. Her voice sounded strange and distant. He wet his lips and looked puzzled. “Say my name again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Abby.” He shook her, one convulsive jerk that traveled up and down her spine like lightning. “Abby, what the hell’s going on?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("She shook her head, too weary to be afraid, and ")]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("scrabbled for a discarded Sonic napkin. She rubbed her mouth with it, then her tongue, until the taste of dirt was gone.")])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "indent1"
  }, [_vm._v("He insisted on taking her to the emergency room, and they waited in a cramped, overheated treatment room while two doctors discussed her in the hall. They frowned a lot. Abby didn’t like the look of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is a waste of time,” she said for about the tenth time. John Lee had heard the accusation before and didn’t bother to respond. He’d settled himself comfortably on a chair near the door, elbows braced on his knees, arms dangling. There didn’t seem to be a tense muscle in him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby could not make the same claim. She had a panicked fear of hospitals, doctors, and needles, and she’d experienced all three in the hour since John Lee had delivered her to the ER door kicking and screaming. She sat at the very edge of the treatment table, legs dangling in space, and practiced the fingerings for the Debussy "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clarinet Concerto")]), _vm._v(", which was the first that came to mind. The flutter of motion soothed her, a little. She tried to hear the piano part, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("there")]), _vm._v(", a cascade of notes like a rainstorm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The music broke off in midmeasure as the treat ment room door opened.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("“Abby, I think we’ve found the problem,” her doctor said without a glance at John Lee. He breezed forward to lay a chart on the treatment bed next her. She shifted nervously away from him and hated the dry crackle of paper underneath her. “Your blood sugar crashed. Now, you did the right thing eating, ")]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("that was fine, but you need to be more careful about what you eat and when you eat it. You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" know you’re hypoglycemic?”")])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know,” she sighed. “But this didn’t feel like—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You did experience disorientation? And a grayout?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shrugged. He beamed, satisfied, and handed her the ubiquitous healthy menu. His lecture was longer than she was used to, so she passed the time by staring at John Lee. His dark hair hung straight near his face, escaped into rebellious waves at the ends. Red where the fluorescents caught highlights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked up around the time the doctor’s lecture was winding down, and their eyes met.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll do that,” she said to the doctor, who was clearly waiting for a response. “Can I go now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t see why not. Go home and rest. Make sure you’re following the menu every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He didn’t insist on a promise, which was good, and he left without any more fuss. She slid off the table and wavered on her high heels, less from dizziness than from unfamiliarity with the shoes. John Lee jumped to his feet and braced her with an arm around her back, one hand holding her forearm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m fine,” she said. “See? Low blood sugar. Gets me every time. First my dog and now me. You must feel like you’re running an ambulance service.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He must have known that she didn’t need the support, but he didn’t let go. She felt the heat of him all along her back, down her arm. It felt like they were dancing, but they were standing very still.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("“It wasn’t blood sugar,” he said. She felt his pulse ")]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_vm._v("through the tips of his fingers where they rested on her skin, “I saw your face, Abby, You weren’t sick, you were scared to death.”")])]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Tears welled up in her eyes, carrying with them a tide of fear she hadn’t known was there. She didn’t know where the feeling came from, or why, but suddenly she could put words to it")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I felt dead,” she said. “Dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Maria had left another note on the coffee table, This one said, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Heard it went great, gone to Memphis, see you Thurs. next")]), _vm._v(". Below that, in tiny script, was, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Took")]), _vm._v(" C "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("to vet. What happened to feet?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carlton licked Abby’s hand, chocolate eyes woeful, and she cheered him up by scratching his neck. He lost interest in her and limped around the couch to sniff John Lee’s blue jeans. John Lee crouched to give him a good-dog shakedown, and Abby couldn’t help but notice that he had one’ of those great cowboy butts, minus the usual can of chewing tobacco in the back pocket. The back of his belt didn’t spell out his name, either. Another plus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My roommate’s gone,” she announced, and immediately regretted it. “Uh, I mean, I can make some dinner if you want to stay. Would you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Lee looked over his shoulder and gave he warm, lopsided smile. “I\n            don’t think that was what the doctor meant when he said to rest. How about I take\n            you someplace?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby kicked off her high heels and resettled her black skirt around her, picking at the folds while she considered.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page47"
    }
  }), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_vm._v("“John …”")])]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Damn")]), _vm._v(" him, she’d never met anybody who read her mind like that. “Another drive-through?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Doctor didn’t exactly recommend it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Screw the doctor!” she snapped, and covered her mouth with her hand, just like she had in high school. John Lee looked mortally amused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do I have to?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I … sorry. I have this thing about doctors. My mother kept taking\n            me to doctors when I was a kid, first this and then that, nothing wrong with me but they\n            kept giving me tests. Painful tests.” When she dreamed, which was often, she\n            wasn’t chased by demons or closet monsters, it was always doctors in white coats,\n            holding syringes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The man was right, you’ve got to eat.” He stood and leaned against the back of the couch, looking down at her. “Here or someplace else, whatever you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She picked up her shoes and started down the hall, careful of the smooth wood in her stockinged feet. “Wherever we’re going, I’m pretty sure I don’t need long black dress,” she called over her shoulder. “Ten minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once she’d shut the door behind her she leaned against it and breathed, deep diaphragmatic breaths like an opera singer. She was being stupid. Rushing headlong toward destruction.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_vm._v("She tossed the high heels in the corner near a drift of other mismatched shoes and yanked open the top drawer of the dresser. Cotton underwear, sports bras, ")]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_vm._v("where the hell … under the dowdy flowered undies she found what she was looking for, the emergency underwear, teal blue satin high-cut panties and a teal-blue satin bra. She struggled out of the concert dress and the matching dreary underwear and stood, naked and shivering, looking at the gleaming Victoria’s Secret arsenal laid out on the bed.")])]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is a mistake.” Her voice echoed hollowly off the cold wood floor. She reached out to touch the satin with a tentative fingertip. “Right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Satin glided cold over her skin, raised goose bumps where it passed. She took a second to stand in front of the mirror, cataloging the faults, and stopped before she lost her courage completely. From the back of her closet came a pair of tight blue jeans and a sweater soft enough to pet. From the litter of makeup on the dresser she found lipstick and applied it, had to do it twice because her hands were shaking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then the perfume. Not too much, nothing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("desperate")]), _vm._v(", just a hint. God, was she doing this right? What was missing? Shoes. She found a pair of flat slip-ons and paused by the door again on the way out. More opera breaths.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she opened the door she found John Lee standing in the hallway, just coming out of the bathroom. She hadn’t expected to see him there and wasn’t prepared for the way he looked at her, the leap of pleasure in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nice,” he said, which somehow was the most genuine compliment she had ever received. “You the one with the subscription to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Playgirl?")]), _vm._v("”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page49"
    }
  }), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_vm._v("Maria insisted on keeping a magazine rack next to the toilet, stuffed with a haphazard mix of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ladies’ Home Journal")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Weekly World News")]), _vm._v(". The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Playgirl")]), _vm._v(" subscription had been a birthday present from Benny. Trust Maria to stuff them in with the other reading material.")])]), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry,” she sighed. “I only read it for the centerfolds.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He held the door open for her on the way out, a strange little smile on his lips. As she passed, he leaned over and said, “Me, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His grin was as good as a laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not, are you?” she asked after they were safely in the car. He froze in the act of hooking his seat belt. “I mean, it’s okay if you are—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her voice didn’t want to come right out and say it, so the word came out small and doubtful. “Gay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He moved far enough to finish fastening the seat belt, to turn the ignition key, then relaxed back in the seat. “No. I’m not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was reminded of the falling sensation earlier, the taste of dirt in her mouth. The confidence beast, frustrated by her lack of failure at the concert, chimed in with a litany of all the things she was doing wrong, how unattractive she was, how big a mistake it all was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Lee asked, “How bad am I screwing up here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excuse me?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_vm._v("“Seems like everything I’ve said to you since you ")]), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_vm._v("opened the door this morning’s gone wrong. You want me to go to hell?”")])]), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She folded her hands carefully in her lap, swallowed a surge of relief so strong it almost choked her, and said, “Kind of a long drive for dinner. Plus I don’t like spicy food.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83fcbcfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter02.vue
// module id = 87
// module chunks = 0